import { render } from "./Paye.vue?vue&type=template&id=08c6ceff&scoped=true"
import script from "./Paye.vue?vue&type=script&lang=js"
export * from "./Paye.vue?vue&type=script&lang=js"

import "./Paye.vue?vue&type=style&index=0&id=08c6ceff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c6ceff"]])

export default __exports__